import { Link } from "react-router-dom";

export default function MusicMasteryCourse() {

    return (
        <>
            <section id="music-mastery-section">
                <div className="mastery-container">
                    <div className="mastery-content">
                        <div className="mastery-left">
                            <div className="section-header">
                                <h2 className="section-title">All In One Music Mastery Course</h2>
                            </div>
                            <div className="mastery-testimonial">
                                <div className="testimonial-text">
                                    <p>The All-In-One Music Mastery Course is HSM’s most exclusive and comprehensive program, created for learners who dream of becoming complete musicians. Instead of limiting yourself to one discipline, this course gives you the unique opportunity to master any three instruments or vocal styles simultaneously, with structured lessons designed by expert mentors.</p>
                                    <p>This program is built to develop not just technical skill but also artistic depth, stage presence, and musical versatility, making it ideal for aspiring professionals, performers, and multi-talented learners.</p>
                                    {/* <p>What You Gain in This Program:</p> */}
                                </div>
                            </div>

                            <div className="mastery-features">
                                <div className="feature-card">
                                    <h4>Multi-Disciplinary Training</h4>
                                    <div className="feature-icon">
                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <path d="M9 18V5l12-2v13" />
                                            <circle cx="6" cy="18" r="3" />
                                            <circle cx="18" cy="16" r="3" />
                                        </svg>
                                    </div>
                                    <p>Learn and excel in any three instruments/voices of your choice.</p>
                                </div>

                                <div className="feature-card">
                                    <h4>Comprehensive Development</h4>
                                    <div className="feature-icon">
                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
                                            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                                            <line x1="12" y1="19" x2="12" y2="23" />
                                            <line x1="8" y1="23" x2="16" y2="23" />
                                        </svg>
                                    </div>
                                    <p>Covers instruments, vocals, music theory, ear training, and stage performance.</p>
                                </div>

                                <div className="feature-card">
                                    <h4>Performance & Ensemble Training</h4>
                                    <div className="feature-icon">
                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <path d="M9 18V5l12-2v13" />
                                            <circle cx="6" cy="18" r="3" />
                                            <circle cx="18" cy="16" r="3" />
                                            <path d="M12 8v8" />
                                            <path d="M8 12h8" />
                                        </svg>
                                    </div>
                                    <p>Learn to perform in ensembles and develop stage presence.</p>
                                </div>

                                <div className="feature-card">
                                    <h4>Creative Growth</h4>
                                    <div className="feature-icon">
                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <path d="M12 2v20M2 12h20" />
                                            <path d="m9 9 6 6" />
                                            <path d="m15 9-6 6" />
                                        </svg>
                                    </div>
                                    <p>Exposure to multiple genres including Western, Bollywood, Classical, Opera, and Contemporary styles.</p>
                                </div>

                                <div className="feature-card">
                                    <h4>Personalized Roadmap</h4>
                                    <div className="feature-icon">
                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <path d="M3 18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10Z" />
                                            <path d="M16 2v4M8 2v4" />
                                            <path d="M3 10h18" />
                                        </svg>
                                    </div>
                                    <p>A fully customized curriculum designed to match your personal goals and pace.</p>
                                </div>

                                <div className="feature-card">
                                    <h4>Career Edge</h4>
                                    <div className="feature-icon">
                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                            <polyline points="22,4 12,14.01 9,11.01" />
                                        </svg>
                                    </div>
                                    <p>Gain versatility that sets you apart as a stage performer, studio musician, or professional artist.</p>
                                </div>
                            </div>
                            <span className="duration"><Link to="/all-in-one">Read More</Link></span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 